import { Loader2 } from 'lucide-react'
import type { PurchaseOrderDetail } from '@/types/purchaseOrders'
import { PO_PAPER, PoDocument } from './PoDocument'
import { PoScaledPreview } from './PoScaledPreview'
import { usePoDocumentInputs } from './usePoDocumentInputs'

/**
 * The order as it will print (z8nrz7f7dz), on screen: the same PoDocument Print
 * and Download PDF render, through the same template (the current one for a
 * draft, the frozen snapshot once sent), scaled to the dialog's width. A draft
 * carries the DRAFT watermark, as it prints.
 */
export function PoDocumentPreview({ po }: { po: PurchaseOrderDetail }) {
  const inputs = usePoDocumentInputs(po)

  if (inputs.error) {
    return <p className='text-sm text-destructive'>The template could not be loaded, so the preview is unavailable.</p>
  }
  if (inputs.isLoading || !inputs.layout) {
    return (
      <div className='flex items-center gap-2 py-10 text-sm text-muted-foreground'>
        <Loader2 className='h-4 w-4 animate-spin' />
        Preparing the preview…
      </div>
    )
  }

  const paper = PO_PAPER[inputs.layout.document.paperSize] ?? PO_PAPER.A4
  return (
    <div className='rounded-xl bg-slate-100 p-4' data-testid='po-document-preview'>
      <PoScaledPreview paperWidthMm={paper.widthMm}>
        <PoDocument
          layout={inputs.layout}
          po={po}
          logoUrl={inputs.logoUrl}
          attributes={inputs.attributes}
          watermark={po.status === 'DRAFT' ? 'DRAFT' : undefined}
          mode='preview'
        />
      </PoScaledPreview>
    </div>
  )
}
